"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserRole = exports.selectUsername = exports.selectIsFeedbackSubmitted = exports.selectIsAuthenticated = exports.selectIsInitialised = undefined;

var _reselect = require("reselect");

var selectMeta = function selectMeta(state) {
  return state.meta;
};

var selectIsInitialised = exports.selectIsInitialised = (0, _reselect.createSelector)(selectMeta, function (meta) {
  return meta.initialised;
});
var selectIsAuthenticated = exports.selectIsAuthenticated = (0, _reselect.createSelector)(selectMeta, function (meta) {
  return meta.isAuthenticated;
});
var selectIsFeedbackSubmitted = exports.selectIsFeedbackSubmitted = (0, _reselect.createSelector)(selectMeta, function (meta) {
  return meta.feedbackSubmitted;
});
var selectUsername = exports.selectUsername = (0, _reselect.createSelector)(selectMeta, function (meta) {
  return meta.username;
});
var selectUserRole = exports.selectUserRole = (0, _reselect.createSelector)(selectMeta, function (meta) {
  return meta.userRole;
});